<template>
  <div class="detail-reward">
    <div class="reward-container" v-if="showDetailRewardBtn">
      <div class="button" @click="handleReward">
        <img class="icon" src="@/assets/reward/currency.png" alt="赞赏" />
        <span class="txt">赞赏</span>
      </div>
    </div>
    <el-dialog
      :visible.sync="visible"
      :show-close="false"
      top="5vh"
      width="fit-content"
      custom-class="detail-reward-dialog"
      append-to-body
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="reward-panel">
        <div class="header">
          <div class="title">优质内容 值得赞赏</div>
          <div class="desc">您的赞赏金额会直接进入作者的gamekee账号</div>
        </div>
        <div class="body">
          <div class="wrapper">
            <div class="reward-list">
              <div class="content">
                <img
                  v-for="(user, index) in rewardUserList"
                  :key="index"
                  :alt="user.username"
                  :style="{ left: `-${index * 8}px` }"
                  :src="user.avatar"
                  class="avatar"
                />
                <span :style="{ 'margin-left': `-${rewardUserList.length}px` }" class="reward-count">
                  {{
                    detail.reward && detail.reward.user_count
                      ? `${detail.reward.user_count}人赞赏了他`
                      : "感谢所有支持和喜欢~"
                  }}
                </span>
              </div>
            </div>
            <div class="reward-price">
              <div
                v-for="price in rewardPriceList"
                :key="price"
                :class="{ 'price-item': true, 'price-item-checked': checkPrice === price }"
                @click="checkPrice = price"
              >
                <span class="number">{{ price }}</span>
                <span class="unit">元</span>
              </div>
              <div
                :class="{ 'price-item': true, 'price-custom': true, 'price-item-checked': checkPrice === '' }"
                @focusin="checkPrice = ''"
              >
                <span>自定义</span>
                <input
                  v-model="customPrice"
                  type="text"
                  placeholder="请输入"
                  maxlength="3"
                  @input="onCustomPriceInput"
                />
              </div>
              <div class="desc">
                <div>1. 仅代表对作者的支持</div>
                <div>2. 通过赞赏支持作者是您自愿的行为</div>
              </div>
            </div>
            <div class="pay-area">
              <div class="qrcode">
                <QrcodeVue :value="qrcodeSrc" :size="101" />
              </div>
              <div class="pay-way">
                <div class="count">
                  <span class="label">扫码支付：￥</span>
                  <span class="value">{{ checkPrice || customPrice }}</span>
                </div>
                <div class="use-way">
                  <span>请使用：</span>
                  <img src="@/assets/reward/pay-ali.png" alt="支付宝" />
                  <span style="margin-right: 12px;">支付宝</span>
                  <img src="@/assets/reward/pay-wechat.png" alt="支付宝" />
                  <span>微信扫码支付</span>
                </div>
                <div class="private">
                  <span class="label">支付即同意</span>
                  <span class="link">
                    <a href="https://www.gamekee.com/wiki/661203.html" target="_blank">
                      《gamekee赞赏服务协议》
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img class="close" src="@/assets/images/share_guide_close.png" alt="关闭" @click="visible = false" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import { apiRewardOrder, apiOrderStateByCode } from "@/api/rewardApi";
import { rewardComplete } from "@/views/wiki/components/reward";

export default {
  name: "DetailReward",
  components: { QrcodeVue },
  props: {
    detail: { type: Object, default: () => ({}) },
    showDetailRewardBtn: { type: Boolean, default: true }
  },
  data() {
    return {
      visible: false,
      rewardPriceList: [3, 6, 10, 18, 36, 68, 88],
      checkPrice: 3,
      customPrice: "",
      qrcodeSrc: "",
      orderCode: "",
      orderPayState: ""
    };
  },
  computed: {
    rewardPrice() {
      return Number(this.checkPrice || this.customPrice);
    },
    rewardUserList() {
      return this.detail.reward?.last_user_list || [];
    }
  },
  watch: {
    rewardPrice: "fetchQrcodeSrc",
    orderPayState(value) {
      if (value === 2) {
        rewardComplete(true);
        // 数据绑定埋点
        if (window.staticFn) {
          window.staticFn.customEvent("appreciate_the_successful_payment_of_the_article", {
            contentId: this.$route.params.id
          });
        }
      }
      if ([-1, -2, -3].includes(value)) {
        rewardComplete(false);
      }
      if (value !== 1) {
        clearTimeout(this.timeoutTimer);
        this.visible = false;
      }
    }
  },
  methods: {
    async fetchQrcodeSrc() {
      const params = {
        amount: this.rewardPrice,
        content_id: this.detail.content_id
      };
      if (!params.amount) return;
      const { code, data } = await apiRewardOrder(params);
      if (code == 0) {
        const orderCode = data.order_code;
        if (process.env.VUE_APP_MODE === "prod") {
          this.qrcodeSrc = `${location.protocol}//${location.host}/reward-redirect/${orderCode}/article`;
        } else {
          this.qrcodeSrc = `http://www.pre.gamekee.com/reward-redirect/${orderCode}/article`;
        }
        this.orderCode = orderCode;
      }
    },
    handleReward() {
      if (this.isLoginShow()) {
        this.visible = true;
        // 数据绑定埋点
        if (window.staticFn) {
          window.staticFn.customEvent("appreciation_article");
        }
      }
    },
    onOpened() {
      this.fetchQrcodeSrc();
      this.loopOrderPayState();
    },
    onClosed() {
      clearTimeout(this.timeoutTimer);
    },
    onCustomPriceInput(event) {
      this.customPrice = event.target.value.replace(/\D/g, "");
      if (this.customPrice === "0") {
        this.customPrice = "";
      }
    },
    loopOrderPayState() {
      this.timeoutTimer = setTimeout(async () => {
        const { code, data } = await apiOrderStateByCode({ code: this.orderCode });
        if (code === 0) {
          this.orderPayState = data.state;
        }
        this.loopOrderPayState();
      }, 2000);
    }
  }
};
</script>
<style scoped>
.reward-panel {
  position: relative;
  width: 546px;
  height: 706px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  /* 只能放到css中，在less中编译出来会失败 */
  background: right 12px top 10px/262px 230px no-repeat url("~@/assets/reward/sun-back.png"),
    left bottom/488px 620px no-repeat url("~@/assets/reward/panel-back.png");
}
</style>
<style lang="less" scoped>
.detail-reward {
  .reward-container {
    margin: 30px auto 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    .button {
      height: 48px;
      width: 137px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(180deg, #51d4ff 0%, #00afe8 100%);
      box-shadow: 0px 2px 0px 0px #1e98bf;
      border-radius: 48px;
      gap: 12px;
      cursor: pointer;
      .icon {
        width: 23px;
        height: 23px;
      }
      .txt {
        color: #fff;
        font-size: 18px;
      }
    }
  }
}
.reward-panel {
  .header {
    width: 224px;
    margin-bottom: 12px;
    .title {
      color: #1c2f38;
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 12px;
    }
    .desc {
      color: #325f6e;
      font-size: 14px;
      line-height: 1.2;
    }
  }
  .body {
    width: 456px;
    border-radius: 20px;
    background-image: conic-gradient(rgb(52, 139, 167), #46b4cd, #46b4cd, rgb(52, 139, 167));
    padding: 1px;
    .wrapper {
      .reward-list {
        padding: 24px 20px;
        border-radius: 18px 18px 0 0;
        background-color: #f6f6f6;
        .content {
          height: 48px;
          display: flex;
          align-items: center;
          background-color: #e9eaeb;
          padding: 0 10px;
          border-radius: 10px;
          .avatar {
            width: 24px;
            height: 24px;
            border-radius: 24px;
            box-sizing: content-box;
            border: 2px solid #fff;
            position: relative;
          }
          .reward-count {
            color: #000000;
            font-size: 14px;
          }
        }
      }
      .reward-price {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        padding: 0 20px 20px;
        gap: 12px;
        background-color: #f6f6f6;
        .price-item {
          display: flex;
          align-items: center;
          justify-content: center;
          column-gap: 4px;
          height: 90px;
          border-radius: 12px;
          box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
          background-image: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
          cursor: pointer;
          .number {
            color: #37748d;
            font-size: 32px;
            font-weight: bold;
          }
          .unit {
            color: #000000;
            font-size: 16px;
          }
        }
        .price-custom {
          display: flex;
          flex-direction: column;
          row-gap: 12px;
          span {
            color: #333333;
            font-size: 12px;
          }
          input {
            row-gap: 4px;
            border: none;
            outline: none;
            height: 30px;
            border-radius: 8px;
            background-color: #f5f5f5;
            line-height: 30px;
            width: 76px;
            text-align: center;
          }
        }
        .price-item-checked {
          position: relative;
          border: 2px solid #00afe8;
          background-image: linear-gradient(180deg, #ecfaff 0%, #ffffff 100%);
          &::after {
            content: url("~@/assets/reward/selection.png");
            position: absolute;
            top: -16px;
            right: -16px;
            transform: scale(0.5);
          }
        }
        .desc {
          grid-column-start: span 4;
          color: #666666;
          font-size: 12px;
        }
      }
      .pay-area {
        display: flex;
        column-gap: 12px;
        background-color: #ffffff;
        padding: 20px;
        border-radius: 0 0 18px 18px;
        /deep/ .qrcode {
          border: 1px solid #e9e9e9;
          padding: 4px;
          & > div {
            line-height: 0;
          }
        }
        .pay-way {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          .count {
            .label {
              color: #000000;
              font-size: 14px;
              font-weight: bold;
            }
            .value {
              color: #000000;
              font-size: 22px;
              font-weight: bold;
            }
          }
          .use-way {
            display: flex;
            align-items: center;
            color: #666666;
            font-size: 13px;
            img {
              width: 20px;
              height: 20px;
            }
          }
          .private {
            font-size: 13px;
            .label {
              color: #666666;
            }
            .link a {
              color: #06b4fd;
            }
          }
        }
      }
    }
  }
  .close {
    width: 32px;
    height: 32px;
    position: absolute;
    bottom: -50px;
    left: 230px;
  }
}
/deep/ .detail-reward-dialog {
  background-color: transparent;
  box-shadow: unset;
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}
</style>
